import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/student-animation-showcase/StudentAnimationShowcaseClient.tsx");
